/**
 * Safe logging helper. Defers to window.app.log once the legacy app
 * namespace has hydrated (app.properties is populated by app.init() on
 * DOMContentLoaded). If called before hydration, defers via the native
 * `ep:ready` event, which app-config.js dispatches after start() finishes.
 * Silent in production because app.log respects the debug flag.
 *
 * Use master-style colored tags for greppable console output:
 *
 *   import { log } from './log.js';
 *   log('[Cart] line items resolved', { added: 1, empty: false });
 *
 * Tag colors are defined in application.esm.js. Common tags: Cart,
 * MiniCart, Form, Add to Cart, Waitlist, Waitlist API, Filter, Notice,
 * Router, Collection, Slider, Hemming, Currency, Maps, Newsletter, Error.
 *
 * Import path note: `./log.js` is the built runtime filename. The source
 * lives at theme/js/core/log.esm.js, but Grunt's copy:esm flattens
 * everything into .build/assets/ with the .esm suffix stripped.
 *
 * AI: Entirely written by AI
 * Date: 2026-04-24
 * Updated: 2026-05-09 (Claude Opus 4.7)
 * Model: Claude Opus 4.7
 */

export function log(...args) {
  const a = window.app;
  const emit = () => {
    if (window.app && window.app.log) {
      window.app.log.apply(window.app, args);
    } else {
      console.log.apply(console, args);
    }
  };
  if (a && a.properties) {
    emit();
  } else {
    document.addEventListener('ep:ready', emit, { once: true });
  }
}
